<template lang="pug">
  v-container(fluid)
    h2.text-center {{ translations.title }}

    v-row.px-2.px-sm-10.pb-10( justify="center")
      v-col(cols="12")
        v-data-table(
          :headers="headers"
          :items="datos"
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
        )
          template(v-slot:body="{ items }")
            tbody
              tr(v-for="item,ind in items", :key="'item'+ind")
                td
                  span.fantasy__block-width--8 {{ item.name }}
                td.text-right {{ item.fee }}
                td {{ item.organizer }}
                td
                  span(v-for="(item,i) in item.jurisdiction", :key="'jurisdiction'+i") {{ item.value }} 
                td
                  BaseConfirmDialog(v-if="hasPermission('views.fantasy.networks.toggleNetwork')" @confirm="toggleState(item._id)" v-bind="translations.confirmationDialog.status")
                    template(v-slot="{ on }")
                      v-btn(v-on="on", :color="getColor(item.disabled)" dark rounded) {{ getStatus(item.disabled) }}
                  v-chip(v-else :color="getColor(item.disabled)" text-color="white") {{ getStatus(item.disabled) }}
                td(v-if="hasPermission('views.fantasy.networks.editNetwork')")
                  BaseDialog(type="edit", :title="translationsForm.title.edit + item.name" v-slot="{close, opened}")
                    NetworkEdit(@successEdit="updateNetwork(opened,close)", :clearForm="opened", :translations="translationsForm", :operatorsList="operatorsListAll", :jurisdictions="jurisdictions", :network="item")

    BaseDialog(v-if="hasPermission('views.fantasy.networks.createNetwork')" type="create", :title="translationsForm.title.create" v-slot="{close, opened}")
      NetworkCreate(@successCreate="updateNetwork(opened,close)", :clearForm="opened", :translations="translationsForm", :operatorsList="operatorsListAll", :jurisdictions="jurisdictions")

</template>

<script>

  import { jurisdictions } from "@/store/variablesGlobals";
  import NetworkCreate from '@/components/forms/NetworkCreate';
  import NetworkEdit from '@/components/forms/NetworkEdit';

  export default {
    name: "NetworksIndex",
    components: {
      NetworkCreate,
      NetworkEdit,
    },
    data: () => ({
      namefilter: '',
      jurisdictions: jurisdictions,
    }),
    computed:{
      translations() {
        return this.$t("views.networksIndex");
      },
      translationsForm() {
        return this.$t("forms.network");
      },
      headers() {
        let headers = [
          {
            text: this.translations.tableHeadText.name,
            value: 'name'
          },
          {
            text: this.translations.tableHeadText.fee,
            value: 'fee'
          },
          {
            text: this.translations.tableHeadText.organizer,
            value: 'organizer'
          },
          {
            text: this.translations.tableHeadText.jurisdiction,
            value: 'jurisdiction'
          },
          {
            text: this.translations.tableHeadText.disabled,
            value: 'disabled'
          }
        ];

        if(this.hasPermission('views.fantasy.networks.editNetwork')){
          headers.push(
            {
              text: '',
              value: 'edit',
              sortable: false
            });
        }
        return headers;
      },
      datos(){
        return this.networksListAll.map(network =>{
          const jurisdictionTmp = typeof network.j == 'string' ? [network.j] : network.j;
          const jurisdictionsSelected = jurisdictions.filter((item)=>{
            return jurisdictionTmp.includes(item.value);
          });
          return {
            _id: network._id,
            name: network.n,
            fee: network.f,
            organizer:network.o.n,
            jurisdiction: jurisdictionsSelected,
            disabled: !network.d,
            members: network.m.map(member => {
              return{
                text:member.n,
                value:member._id
              }
            }),
            editOrganizer:{
              text:network.o.n,
              value:network.o._id
            },
          }
        })
      },
      networksListAll() {
        return this.$store.state.fantasy.networks;
      },
      networksMembers(){
        if(this.networksListAll.length > 0){
          return this.networksListAll.m.map(members => {
            return{
              text:members.n,
              value:members._id
            }
          });
        } else {
          return []
        }
      },
      operatorsListAll() {
        return this.$store.state.operators.map(operator => ({
          text: operator.n,
          value: operator._id,
          jurisdiction: operator.j,
        }));
      },
      statusAsyncState(){
        return this.$store.state.statusCode.toggleNetwork.state || '';
      },
    },
    watch: {
      statusAsyncState: function(val){
        if (val == 200){
          this.$store.dispatch('getNetworks');
        }
      },
    },
    created() {
      this.$store.dispatch('getNetworks');
      this.$store.dispatch('getOperators');
    },
    methods:{
      getNetworks(){
        this.$store.dispatch('getNetworks');
      },
      updateNetwork(opened, closedialog){
        if(opened) {
          if(closedialog != undefined){
            closedialog();
          }
          this.$store.dispatch('getNetworks');
        }
      },
      toggleState(networkid){
        this.$store.dispatch('toggleNetwork', networkid);
      },
      getColor(type){
        return type == true ? 'green' : 'red' ;
      },
      getStatus(type){
        return type == true ? this.translations.status.enabled : this.translations.status.disabled;
      }
    }
  }
</script>

<style lang="sass">
</style>